<template>
    <div class="home-header grid-100 grid-parent grid-container" :style="{ height: `${this.windowH - 100}px` }">
        <div class="tv-home-animation">
            <figure class='tv-home-figure' >
                <!-- <div 
                    v-for="(content, key) in tvData"
                    :key="key"
                    class="tv-glitch"
                    :class="key"
                    <img src="static/tvs/glitch-gif-1c.jpg" alt="static tv">
                    <router-link :to="content.destination" v-if="!content.destination.includes('http')">
                        <span class='new-dates' :class="[content.colour, content.size]" v-html="content.text"></span>
                    </router-link>
                    <a :href="content.destination" v-else v-html="content.text" :class="content.size"></a>
                </div>
                > -->
                <div class="tv-glitch tv-1">
                    <img src="static/tvs/glitch-gif-1c.jpg" alt="static tv">
                    <a :href="tvData.tv3_link" :class="tvData.tv3_colour" target="_blank"><span class='new-dates' v-html="tvData.tv3_text"></span></a>
                </div>
                <div class="tv-glitch tv-2">
                    <img src="static/tvs/glitch-gif-1c.jpg" alt="static tv">
                    <router-link :to="{ name: 'Shows', params: { tour: tvData.tv1_slug } }" :class="tvData.tv1_colour">
                        <span class='new-dates' v-html="tvData.tv1_text"></span>
                    </router-link>

                    <!-- <a v-link="{ path: tvData.tv1_link, params: { tour: 'humournoid-australian-tour-2020'}}" :class="tvData.tv1_colour"><span class='new-dates' v-html="tvData.tv1_text"></span></a> -->
                </div>
                <div class="tv-glitch tv-3">
                    <img src="static/tvs/glitch-gif-1c.jpg" alt="static tv">
                    <a :href="tvData.tv2_link" :class="tvData.tv2_colour" target="_blank"><span class='' v-html="tvData.tv2_text"></span></a>
                </div>
                <div class="tv-glitch tv-4">
                    <img src="static/tvs/glitch-gif-1c.jpg" alt="static tv">
                   <!--  <a :href="tvData.tv5_link" :class="tvData.tv5_colour"><span class='' v-html="tvData.tv5_text"></span></a> -->
                   <router-link :to="{ name: 'Shows', params: { tour: tvData.tv5_slug } }" :class="tvData.tv5_colour">
                        <span class='' v-html="tvData.tv5_text"></span>
                    </router-link>
                </div>
                <div class="tv-glitch tv-5">
                    <img src="static/tvs/glitch-gif-1c.jpg" alt="static tv">
                    <a :href="tvData.tv4_link" :class="tvData.tv4_colour" target="_blank"><span class='' v-html="tvData.tv4_text"></span></a>
                </div>
                <div class="tv-glitch tv-6">
                    <img src="static/tvs/glitch-gif-wobble.gif"/>
                </div>
                <div class="tv-glitch tv-7">
                    <img src="static/tvs/glitch-gif-rgb-1.gif"/>
                </div>
                <div class="tv-glitch tv-8">
                    <img src="static/tvs/glitch-gif-wobble.jpg"/>
                </div>
                <div class="tv-glitch tv-9">
                    <img src="static/tvs/glitch-gif-wobble.gif"/>
                </div>
                <div class="tv-glitch tv-10">
                    <img src="static/tvs/glitch-gif-rgb-1.jpg"/>
                </div>
                <div class="tv-glitch tv-11">
                    <img src="static/tvs/glitch-gif-rgb-1.jpg"/>
                </div>
                <div class="tv-glitch tv-12">
                    <img src="static/tvs/glitch-gif-wobble.jpg"/>
                </div>
                <div class="tv-glitch tv-13">
                    <img src="static/tvs/glitch-gif-rgb-1.jpg"/>
                </div>
                <div class="tv-glitch tv-14">
                    <img src="static/tvs/glitch-gif-wobble.jpg"/>
                </div>
                <div class="tv-glitch tv-15">
                    <img src="static/tvs/glitch-gif-wobble.jpg"/>
                </div>
                <div class="tv-glitch tv-16">
                    <img src="static/tvs/glitch-gif-rgb-1.jpg"/>
                </div>
                <div class="tv-glitch tv-17">
                    <img src="static/tvs/glitch-gif-rgb-1.jpg"/>
                </div>
                <img src="../assets/images/tv-3b.png" class="tv-background"/>
            </figure>
            
        </div>
    </div>
</template>

<script>
import { apiRequest } from "../services";

export default {
    name: "TvHeader",
    fallbackData: {
        "tv1_colour": "orange",
        "tv1_link": "#/shows",
        "tv1_text": "NewUK TourSep - Dec 2018",
        "tv2_colour": "white",
        "tv2_link": "#/ondemand?autoplay=1",
        "tv2_text": "WATCHFREE SHOW",
        "tv3_colour": "orange",
        "tv3_link": "#/shows/humournoid-uk-tour-2021",
        "tv3_text": "NewAUS TourJul - Aug 2018",
        "tv4_colour": "white",
        "tv4_link": "https://officiallondontheatre.com/olivier-awards/year/2018/",
        "tv4_text": "2018Olivier award nominee",
        "tv5_colour": "white",
        "tv5_link": "#/offstage?autoplay=1",
        "tv5_text": "WATCH FREEDOCUMENTARY",

        // "tv-1": {
        //     destination: "/shows/el-hablador-australia",
        //     text: "New<br>AUS Tour<br>Jul - Aug 2018",
        //     colour: "orange",
        // },
        // "tv-2": {
        //     destination: "/shows/el-hablador-uk",
        //     text: "New<br>UK Tour<br>Sep - Dec 2018",
        //     colour: "orange",
        // },
        // "tv-3": {
        //     destination: "/ondemand?autoplay=1",
        //     text: "<span>WATCH<br>FREE SHOW</span>",
        //     colour: "white",
        //     size: "small",
        // },
        // "tv-4": {
        //     destination: "/offstage?autoplay=1",
        //     text: "<span>WATCH FREE<br>DOCUMENTARY</span>",
        //     colour: "white",
        //     size: "small",
        // },
        // "tv-5": {
        //     destination: "https://officiallondontheatre.com/olivier-awards/year/2018/",
        //     text: "<span>2018<br>Olivier award nominee</span>",
        //     colour: "white",
        // },
    },
    props: {
        windowH: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            tvData: {},
        };
    },
    mounted() {
        const tvData = apiRequest("tv_configurator");
        
        tvData
            .then(this.receivedData)
            .catch(this.fetchFailed)
    },
    methods: {
        receivedData(json) {
            console.log('json', Array.isArray(json));
            if (Array.isArray(json) && json instanceof Object) {
                this.tvData = Object.assign({}, this.fallbackData, json[0]);
                this.tvData.tv1_slug = this.tvData.tv1_link.split('tour=').pop();
                this.tvData.tv2_slug = this.tvData.tv2_link.split('tour=').pop();
                this.tvData.tv3_slug = this.tvData.tv3_link.split('tour=').pop();
                this.tvData.tv4_slug = this.tvData.tv4_link.split('tour=').pop();
                this.tvData.tv5_slug = this.tvData.tv5_link.split('tour=').pop();
                console.log('this.tvData', this.tvData);
            } else {
                this.tvData = Object.assign({}, this.$options.fallbackData);
            }
        },
        /**
         * If the fetch fails then we use the data that was active on the
         * website before the CMS handover. This is to handle the handover
         * period in which there may not be any content.
         */
        fetchFailed(e) {
            console.log("There was an error when fetching the data: ", e);

            this.tvData = Object.assign({}, this.$options.fallbackData);
        },
    },
};
</script>


// WEBPACK FOOTER //
// TvHeader.vue?8790891c